// 导入组件，组件必须声明 name
import MessageCenterList from './src/index';
import env from './src/utils/env';
import vueI18n from '@/i18n/locale';

// 导出组件
let instance;
let IVue = null;

class MessagePlugin {
  install(Vue, options, isRegisterGlobal) {
    const { config, ...other } = options;
    env.set('options', other);
    env.set('config', config);
    if (isRegisterGlobal) {
      Vue.component(MessageCenterList.name, MessageCenterList);
    }
    IVue = Vue;
  }

  open() {
    let MessageConstructor = IVue.extend(MessageCenterList);
    if (!instance) {
      instance = new MessageConstructor({
        i18n: vueI18n,
      });
      instance.$mount();
      document.body.appendChild(instance.$el);
    }
    instance.show = true;
    return instance;
  }

  close() {
    if (instance) {
      instance.show = false;
    }
  }
}

export default new MessagePlugin();
